import { ApiService } from 'app/api/index';
import { IApplicationContext } from 'app/context/types';
import { Region } from 'modules/RegionsConfiguration/constants/enums';

export class DashboardService {
	private apiService: ApiService;

	constructor(private applicationContext: IApplicationContext) {
		this.apiService = new ApiService(this.applicationContext);
	}

	getAllStats() {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().DASHBOARD.GET_ALL_STATS,
					{},
				)
				.then((res: any) => {
					resolve(res.data);
				})
				.catch(e => {
					reject(e);
				});
		});
	}

	getNewUsersCountsStats(fromDate: string, toDate: string) {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().DASHBOARD
						.GET_NEW_USERS_COUNTS_STATS,
					null,
					{
						pathParams: { fromDate, toDate },
					},
				)
				.then((res: any) => {
					resolve(res.data);
				})
				.catch(e => {
					reject(e);
				});
		});
	}

	getActiveUsersCountsStats(fromDate: string, toDate: string) {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().DASHBOARD
						.GET_ACTIVE_USERS_COUNTS_STATS,
					null,
					{
						pathParams: { fromDate, toDate },
					},
				)
				.then((res: any) => {
					resolve(res.data);
				})
				.catch(e => {
					reject(e);
				});
		});
	}

	getRegionsUsersCountsStats() {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().DASHBOARD
						.GET_REGIONS_USERS_COUNTS_STATS,
					{},
				)
				.then((res: any) => {
					resolve(res.data);
				})
				.catch(e => {
					reject(e);
				});
		});
	}

	getRegionLessonsUsersCountsStats(region: Region) {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().DASHBOARD
						.GET_COMPLETED_REGION_LESSONS_USERS_COUNTS_STATS,
					null,
					{
						pathParams: { region },
					},
				)
				.then((res: any) => {
					resolve(res.data);
				})
				.catch(e => {
					reject(e);
				});
		});
	}
}
